import { ReactNode, createContext, useContext, useMemo, useState } from 'react';
import { usePersistentSearch } from 'customHooks/usePersistentSearch';

type CampaignMembersTab = 'individuals' | 'invites';

type CampaignMembersContextType = {
    search: string;
    setSearch: (val: string) => void;
    currentTab: CampaignMembersTab;
    setCurrentTab: (tab: CampaignMembersTab) => void;
};

const defaultContextValue: CampaignMembersContextType = {
    search: '',
    setSearch: () => {},
    currentTab: 'individuals',
    setCurrentTab: () => {},
};

const CampaignMembersContext = createContext<CampaignMembersContextType>(defaultContextValue);

const useCampaignMembers = () => useContext(CampaignMembersContext);

const CampaignMembersProvider = ({ children }: { children: ReactNode }) => {
    const [search, setSearch] = usePersistentSearch();
    const [currentTab, setCurrentTab] = useState<CampaignMembersTab>('individuals');

    const contextValue = useMemo(
        () => ({
            search,
            setSearch,
            currentTab,
            setCurrentTab,
        }),
        [search, setSearch, currentTab],
    );

    return (
        <CampaignMembersContext.Provider value={contextValue}>
            {children}
        </CampaignMembersContext.Provider>
    );
};

export type { CampaignMembersTab };

export { CampaignMembersProvider, useCampaignMembers };
